<template>
    <div data-testid="queries-list-new">
      <div class="all-height d-flex justify-center" data-testid="queries-list-new__main">
        <div class="all-width" data-testid="queries-list-new__panel">
          <v-card :loading="loading" :disabled="loading" loader-height="2" class="shadow-off" data-testid="queries-list-new__card">
            <v-card-text class="pb-0" data-testid="queries-list-new__header-section">
  
              <div data-testid="queries-list-new__breadcrumbs">
                <div class="d-flex" data-testid="queries-list-new__breadcrumbs-row">
                  <p class="mb-1" data-testid="queries-list-new__breadcrumb-home">Home</p>
                  <p class="px-2 mb-1" data-testid="queries-list-new__breadcrumb-sep">/</p>
                  <p class="mb-1" data-testid="queries-list-new__breadcrumb-empty"></p>
                </div>
                <div class="d-flex" data-testid="queries-list-new__title-row">
                  <p class="black--text font-weight-bold font-size-lg" data-testid="queries-list-new__title">Virtual Concierge</p>
                  <v-tooltip bottom content-class="tooltip-bottom" data-testid="queries-list-new__refresh-tooltip">
                    <template v-slot:activator="{ on, attrs }"> 
                        <v-btn 
                            data-testid="queries-list-new__refresh-btn"
                            v-bind="attrs"
                            v-on="on"
                            class="shadow-off ml-1" icon @click="refreshData()"><v-icon
                            size="24" data-testid="queries-list-new__refresh-icon">mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                    <span data-testid="queries-list-new__refresh-label">Refresh</span>
                  </v-tooltip>
                </div>
              </div>
  
  
              <div class="d-flex align-center" data-testid="queries-list-new__search-row">
                <lb-string data-testid="queries-list-new__search-input" label="Search" width="30vh" prependiconinner="mdi-magnify" outlined hidedetails
                  v-model="seachList"></lb-string>
                <v-spacer></v-spacer>
                <v-btn data-testid="queries-list-new__new-btn" v-if="$nova.hasRight(right, 'add')" rounded color="primary"
                  @click="queriesDilog = true; queriesObject = {}; error = {};" elevation="0" 
                  class="white--text mr-2">
                  <v-icon class="mr-1" data-testid="queries-list-new__new-icon">mdi-plus</v-icon><span data-testid="queries-list-new__new-label">New</span>
                </v-btn>
              </div>
            </v-card-text>
            <v-card-text data-testid="queries-list-new__table-section">
  
  
              <lb-datatableaction data-testid="queries-list-new__datatable" v-if="queriesData.length>0" :headers="queriesHeader" :tabledata="queriesData" itemsperpage="" searchterm=""
                :bulkActions="false" :selectfilter="selectfilter" :page_details="page_details">
  
                <template v-slot:tbody>
                  <tr data-testid="queries-list-new__row" v-for="(item, index) in queriesData" :key="item._id" class="cursor-pointer  "
                    :class="{ 'low-opacity': item.status === false }">
                    <template v-for="header in queriesHeader">
                      <td data-testid="queries-list-new__cell" v-if="header.visible && header.value !== 'action'" :key="header.value" class="px-4 single-line">
                        
                        <div data-testid="queries-list-new__cell-stage" v-if="header.value ==='stage'">
                          <v-chip data-testid="queries-list-new__chip-close" label v-if="item.stage === 1" color="lightgreen" class="green--text"><span data-testid="queries-list-new__chip-close-label">Close</span></v-chip>
                          <v-chip data-testid="queries-list-new__chip-open" label v-else color="lightblue" class="blue--text"><span data-testid="queries-list-new__chip-open-label">Open</span></v-chip>
                        </div>
                        <span data-testid="queries-list-new__cell-no" v-else-if="header.value ==='no'">
                          {{ index+1 }}
                        </span>
                        <span data-testid="queries-list-new__cell-value" v-else>
                          {{ item[header.value] }}
                        </span> 
  
                      </td>
                    </template>
                    <td data-testid="queries-list-new__cell-action" class="d-flex align-center px-3 single-line border-right border-left action-data">
                      <div class="d-flex align-center justify-center" data-testid="queries-list-new__action-group">
                        
                        <v-tooltip bottom content-class="tooltip-bottom" data-testid="queries-list-new__view-tooltip">
                          <template v-slot:activator="{ on, attrs }"> 
                            <v-btn data-testid="queries-list-new__view-btn" @click="
                              $nova.gotoLink({ path: 'support/' + item._id })
                              "  v-bind="attrs"
                              v-on="on" class="view-on-hover-item-d mx-0 px-0" icon><v-icon data-testid="queries-list-new__view-icon">mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span data-testid="queries-list-new__view-label">View</span>
                        </v-tooltip>

                        <!-- <Conversation heading="Conversation" width="600" :loading="loading" :recurring="true"
                          :recurringText="recurringContent" :notify="false" :projectid="item._id" :getApi="getURL"
                          :sendApi="sendURL" /> -->
                      </div>
                    </td>
                  </tr>
                </template>
              </lb-datatableaction>

              <div class="d-flex align-center justify-center" v-else data-testid="queries-list-new__empty-state">
                NO DATA
              </div>
  
  
            </v-card-text>
          </v-card>
        </div>
      </div>


      <lb-drawer data-testid="queries-list-new__drawer" v-model="queriesDilog" :heading="queriesObject._id ? 'Update' : 'Add'"
            width="600" :loading="queriesloading">
            <template v-slot:body>
                <div data-testid="queries-list-new__drawer-body">
                  <v-row>
                    <v-col cols="12" class="my-0 py-1" data-testid="queries-list-new__drawer-request-row">
                      <p class="pa-0 ma-0  text-font-size-md" data-testid="queries-list-new__drawer-request-label">Request</p>
                      <lb-string data-testid="queries-list-new__drawer-request-input" label="" :isRequired="true" placeholder="Enter request" v-model="queriesObject.issue" :error="errors['issue']" />
                    </v-col>
                    <v-col cols="12" class="my-0 py-1" data-testid="queries-list-new__drawer-description-row">
                      <p class="pa-0 ma-0  text-font-size-md" data-testid="queries-list-new__drawer-description-label">Description</p>
                      <lb-textarea data-testid="queries-list-new__drawer-description-input" v-model="queriesObject.description" label="" placeholder="Enter request descprition" :error="errors['description']" />
                    </v-col>
                  </v-row>
                </div>
            </template>
            <template v-slot:actions>
                <v-switch data-testid="queries-list-new__drawer-switch" :label="enableSwitch === true ? 'Enable' : ' Disable'" class="mt-0" v-model="enableSwitch"
                    @onchange="toggleSwitch(locationdata)" inset hide-details></v-switch>
                <v-spacer></v-spacer>
                <v-btn data-testid="queries-list-new__drawer-update-btn" color="primary" class="white--text" v-if="queriesObject._id" @click="productUpdate()"><span data-testid="queries-list-new__drawer-update-label">Update</span></v-btn>
                <v-btn data-testid="queries-list-new__drawer-create-btn" color="primary" class="white--text" v-else @click="createQuerie()"><span data-testid="queries-list-new__drawer-create-label">Create</span></v-btn>
            </template>
        </lb-drawer>

      </div>
  </template>
  
  <script>
  // import Conversation from "../common/Conversation.vue";
  export default {
    name: "helpdesk_list",
    data() {
      return {
        right: "helpdesk",
        getURL: "/v2/bot/analysis/getbotconversation/",
        sendURL: "/v2/bot/analysis/addbotconversation",
        recurringContent: "Is it possible to append comment in requirements sdsdfs sdfsdf sdfsd asdsadawd ",
        loading: false,
        errors: {},
        queriesObject: {},
        queriesDilog: false,
        queriesloading: false,
        queriesHeader: [
          { text: "No", value: "no", sortable: false, filterable: false, visible: true },
          { text: "Request", value: "issue", sortable: false, filterable: false, visible: true },
          { text: "Description", value: "description", sortable: false, filterable: false, visible: true },
          { text: "Type", value: "type", sortable: false, filterable: false, visible: true, align: "center" },
          { text: "Stage", value: "stage", sortable: false, filterable: false, visible: true, align: "center" },
          { text: "Action", value: "action", sortable: false, filterable: false, visible: true, align: "center" },
        ],
        seachList: null,
        queriesData: [],
      };
    },
    components: {
      // Conversation,
    },
    created() {
      this.refreshData();
    },
    activated() {
      this.refreshData();
    },
    props: {
      project: {
        type: String,
        default: "",
      },
      type: {
        type: String,
        default: "",
      },
      typenot: {
        type: String,
        default: "",
      },
    },
    methods: {
      refreshData() {
        this.loading = true;
        let nfltr = { modulename: this.$route.meta.modulename };
        if (this.type) nfltr.type = this.type;
        if (this.typenot) nfltr.typenot = this.typenot;
        if (this.project) nfltr.project = this.project;
        this.axios
          .post("/v2/helpdesk/queries/getqueriesbyclient", { filter: nfltr })
          .then((dt) => {
            this.queriesData = dt.data.data;
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
  
      createQuerie() {
        this.queriesloading = true;
        // console.log(this.$route.mata.modulename, "this.$route.mata.modulename");
        this.queriesObject.modulename = this.$route.meta.modulename;
        this.axios
          .post("/v2/helpdesk/queries/add", { data: this.queriesObject })
          .then((dt) => {
            if (dt.data.status === "success") {
              this.refreshData();
              this.$store.commit("sbSuccess", "New Query Added successfully");
              this.queriesDilog = false;
            } else {
              if (dt.data.data.length > 0) {
                if (dt.data.data[0].index0) this.errors = dt.data.data[0].index0;
              }
              throw new Error(dt.data.message || "Error Add Query");
            }
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.log(err);
          })
          .finally(() => {
            this.queriesloading = false;
          });
      },
      QuerieUpdate() {
        this.loading = true;
        this.queriesObject.modulename = this.$store.state.modulename;
        this.axios
          .post("/v2/helpdesk/queries/edit/" + this.queriesObject._id, {
            data: this.queriesObject,
          })
          .then((dt) => {
            if (dt.data.status === "success") {
              this.refreshData();
              this.$store.commit("sbSuccess", "New Query Added successfully");
              this.refreshData();
              this.queriesDilog = false;
            } else {
              if (dt.data.data.length > 0) {
                if (dt.data.data[0].index0) this.errors = dt.data.data[0].index0;
              }
              throw new Error(dt.data.message || "Error Add Query");
            }
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
  </script>
  